import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  List,
  Grid,
  Typography,
  ListItem,
  ListItemSecondaryAction,
  Hidden,
} from '@material-ui/core'
import { Tab } from '@material-ui/icons'
import { FileDocument } from 'mdi-material-ui'
import { withRouter } from 'react-router-dom'
import { toggleExpandPanel } from 'actions/signupForm'
import styles from '../styles'
import {
  azSelector,
  zaSelector,
  oldestFirstSelector,
  newestFirstSelector,
} from 'selectors'
import DeleteMenu from './DeleteMenu'
import language from 'utils/vast-languagepack'
import Icon from '@mdi/react'
import { mdiPlus } from '@mdi/js'

export default withRouter(
  connect(
    state => ({
      forms: state.signupForm.forms,
      expanded: state.signupForm.panelExpanded,
      sort: state.signupForm.sort,
      az: azSelector(state),
      za: zaSelector(state),
      oldestFirst: oldestFirstSelector(state),
      newestFirst: newestFirstSelector(state),
    }),
    dispatch => bindActionCreators({ toggleExpandPanel }, dispatch)
  )(
    withStyles(styles)(
      ({
        classes,
        forms,
        toggleExpandPanel,
        expanded,
        sort,
        az,
        za,
        oldestFirst,
        newestFirst,
        history,
      }) => {
        const sorted = { az, za, oldestFirst, newestFirst }
        const list = sorted[sort].map((form, idx) => {
          const date = new Date(form.when_created)

          return (
            <ListItem
              style={{border: 'solid 1px #adadad'}}
              key={`formsPageListItem${idx}`}
              onClick={() => history.push(`/forms/${form.id}`)}
              button
              classes={{ button: classes.listItemButton }}
            >
              <div className={classes.expandPanelIcon}>
                {form.display_type === 'popover' ? (
                  <div>
                    <Tab />
                    <Typography className={classes.expandPanelIconTypography}>
                      {language.signupform.popover}
                    </Typography>
                  </div>
                ) : (
                  <div>
                    <FileDocument />
                    <Typography className={classes.expandPanelIconTypography}>
                      {language.signupform.embedForm}
                    </Typography>
                  </div>
                )}
              </div>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.newHeading}>
                    <span className={classes.text}>
                      {form.name}
                    </span>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.createdHeading}>
                    <span className={classes.text}>
                      <span>{language.signupform.created}{' '}</span>
                      <span className={classes.createdDate}>
                        {`${date.toLocaleDateString()}`}
                      </span>
                    </span>
                  </div>
                </Grid>
              </Grid>
              <Hidden smDown>
                <div className={classes.newSecondaryHeading}>
                  {`${
                    form.stats && form.stats.visits > 0
                      ? Math.round(
                          (form.stats.submissions / form.stats.visits) * 100
                        )
                      : '--'
                  }% ${language.signupform.add.responded}`}
                </div>
                <div className={classes.newThirdHeading}>
                  {`${
                    form.stats && form.stats.visits ? form.stats.visits : 0
                  } Visits`}
                </div>
              </Hidden>
              <Hidden mdUp>
                <Grid container style={{ width: 'auto' }}>
                  <Grid style={{ marginBottom: '3px' }} item xs={12}>
                    <div
                      style={{ marginRight: '32px'}}
                      className={classes.newSecondaryHeading}
                    >
                      {`${
                        form.stats && form.stats.visits > 0
                          ? Math.round(
                              (form.stats.submissions / form.stats.visits) * 100
                            )
                          : '--'
                      }% ${language.signupform.add.responded}`}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      className={classes.newThirdHeading}
                    >
                      {`${
                        form.stats && form.stats.visits ? form.stats.visits : 0
                      } Visits`}
                    </div>
                  </Grid>
                </Grid>
              </Hidden>
              <ListItemSecondaryAction style={{ top: '10%' }}>
                <DeleteMenu vert formName={form.name} formID={form.id} history={history} />
              </ListItemSecondaryAction>
            </ListItem>
          )
        })
        
        const NoResults = <div style={{textAlign: 'center', marginTop: '40px', fontSize: '20px'}}>
          {language.signupform.noFormDisplay}<br />
          <div
            style={{
              textAlign: 'center',
              fontSize: '20px',
              backgroundColor: '#014c94',
              color: '#ffffff',
              padding: '1%',
              maxWidth: '300px',
              borderRadius: '20px',
              margin: '40px auto 40px auto',
              border: '1px solid black',
              cursor: 'pointer',
              boxShadow:
                '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
            }}
            onClick={() => history.push('/forms/new')}
          >
            <Icon path={mdiPlus} size={4} color='white' />
            <br />
            {language.signupform.createForm}
          </div>
        </div>
        return (
          <div className={classes.listContainer}>
            <Hidden smUp>
              <List dense style={{ padding: 0 }}>
                {list? list.length? list:NoResults:NoResults}
              </List>
            </Hidden>
            <Hidden xsDown>
              <List style={{ padding: 0 }}>{list? list.length? list:NoResults:NoResults}</List>
            </Hidden>
          </div>
        )
      }
    )
  )
)
